module.exports = __webpack_public_path__ + "img/integral_3.6928b99d.png";